import { pick } from 'lodash/fp';

import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from '../utils';

const BASE_PATHNAME = 'live-blogs';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getBlogId = () => dataSource.get(`${BASE_PATHNAME}/new-id`).json();

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['dateFilter', 'eventId']),
    }),
    getBlogId,
    getEmptyList: getDefaultEmptyList,
  };
};
